<template>
  <ColumnContent :title="t('Врачи', options)">
    <a
      v-for="speciality in context.specialities"
      :key="speciality.translit"
      class="d-table text--text link-decoration-none mb-4 text-body-1"
      data-qa="doctor-list"
      :href="reverseFullL10N({ name: 'town_speciality', args: { spec_translit: speciality.translit, language: urlLang } })"
    >
      {{ transDynamic(speciality, `name,${language},${needTranslate}`) }}
    </a>
  </ColumnContent>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore, useURLStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import { ContextStore } from 'src/components/pages/vrach/index/types'

// @ts-ignore
const { context, urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const { t, language } = I18NextVue
const options = { ns: language }
const needTranslate = context.feature_flags.pd_l10n_footer_pages
</script>
